import { Link } from "react-router-dom";
import { Mail, Phone, MessageCircle, MapPin, Clock } from "lucide-react";
import { SERVICES } from "@/data/services";
import { INDUSTRIES } from "@/data/industries";
import { SITE, waLink } from "@/data/site";

const QUICK = [["Home", "/"], ["About Us", "/about"], ["Services", "/services"], ["Industries", "/industries"], ["Solutions", "/solutions"], ["Portfolio", "/portfolio"], ["Testimonials", "/testimonials"], ["Our Process", "/process"], ["Contact", "/contact"], ["Sitemap", "/sitemap"]];

const Col = ({ title, links, testId }) => (
  <div data-testid={testId}>
    <h2 className="text-xs font-bold uppercase tracking-[0.2em] text-ink/60">{title}</h2>
    <ul className="mt-5 space-y-2.5">
      {links.map(([n, to]) => (
        <li key={to + n}><Link to={to} className="text-sm text-ink/80 hover:text-ink hover:underline underline-offset-4">{n}</Link></li>
      ))}
    </ul>
  </div>
);

export const Footer = () => (
  <footer className="bg-sand" data-testid="site-footer">
    <div className="container-x py-16 md:py-20">
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <Link to="/" aria-label="Athlevo IT Solution — Home">
            <img src="/images/athlevo-logo-sm.webp" alt="Athlevo IT Solution — Technology That Moves Your Business Forward" width="640" height="221" loading="lazy" className="h-20 w-auto" />
          </Link>
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-ink/75">
            Websites, custom software, CRM, membership, booking, mobile apps, e-commerce, automation and digital marketing for fitness, sports and wellness businesses worldwide.
          </p>
        </div>
        <div className="grid grid-cols-2 gap-10 sm:grid-cols-3 lg:col-span-5">
          <Col title="Quick links" links={QUICK} testId="footer-quick-links" />
          <Col title="Services" links={SERVICES.slice(0, 7).map((s) => [s.name, `/services/${s.slug}`])} testId="footer-services" />
          <Col title="Industries" links={INDUSTRIES.slice(0, 7).map((i) => [i.name, `/industries/${i.slug}`])} testId="footer-industries" />
        </div>
        <div className="lg:col-span-3" data-testid="footer-contact">
          <h2 className="text-xs font-bold uppercase tracking-[0.2em] text-ink/60">Contact</h2>
          <ul className="mt-5 space-y-3 text-sm text-ink/80">
            <li><a href={`mailto:${SITE.email}`} className="flex items-center gap-2 hover:text-ink" data-testid="footer-email"><Mail className="h-4 w-4" aria-hidden />{SITE.email}</a></li>
            {SITE.phones.map((p) => (
              <li key={p.href}><a href={p.href} className="flex items-center gap-2 hover:text-ink"><Phone className="h-4 w-4" aria-hidden />{p.label}</a></li>
            ))}
            <li><a href={waLink()} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 font-semibold text-ink" data-testid="footer-whatsapp"><MessageCircle className="h-4 w-4" aria-hidden />WhatsApp us</a></li>
            <li className="flex items-center gap-2" data-testid="footer-hours"><Clock className="h-4 w-4" aria-hidden />{SITE.hours.label}</li>
            <li className="flex gap-2 leading-relaxed"><MapPin className="mt-0.5 h-4 w-4 shrink-0" aria-hidden />{SITE.address}</li>
          </ul>
        </div>
      </div>
      <div className="mt-14 flex flex-col gap-4 border-t border-ink/15 pt-8 text-xs text-ink/70 md:flex-row md:items-center md:justify-between">
        <p data-testid="footer-copyright">© {new Date().getFullYear()} {SITE.name}. All rights reserved.</p>
        <div className="flex gap-5">
          <Link to="/privacy-policy" className="hover:text-ink" data-testid="footer-privacy">Privacy Policy</Link>
          <Link to="/terms-and-conditions" className="hover:text-ink" data-testid="footer-terms">Terms & Conditions</Link>
          <Link to="/sitemap" className="hover:text-ink">Sitemap</Link>
        </div>
      </div>
    </div>
  </footer>
);
